import React from 'react';
import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';

type ApprovedFile = {
  fileId: string;
  fileName: string;
  approvedAt: Date;
};

type ApprovedFilesBannerProps = {
  approvedFiles: ApprovedFile[];
};

const formatApprovedAt = (approvedAt: Date) => {
  try {
    return approvedAt.toLocaleDateString();
  } catch {
    return '';
  }
};

export const ApprovedFilesBanner: React.FC<ApprovedFilesBannerProps> = ({
  approvedFiles,
}) => {
  if (!approvedFiles.length) {
    return null;
  }

  return (
    <Box
      mb={6}
      p={4}
      bg="green.50"
      borderRadius="lg"
      border="1px solid"
      borderColor="green.200">
      <Text fontSize="md" fontWeight={600} color="green.800" mb={2}>
        Approved Files:
      </Text>
      <VStack align="start" spacing={2}>
        {approvedFiles.map((file) => (
          <HStack key={file.fileId} spacing={3}>
            <Icon iconName="check" w="16px" h="16px" />
            <Text fontSize="sm">
              {file.fileName || `File ID: ${file.fileId}`}
            </Text>
            {file.approvedAt && (
              <Text fontSize="xs">
                (Approved on {formatApprovedAt(file.approvedAt)})
              </Text>
            )}
          </HStack>
        ))}
      </VStack>
    </Box>
  );
};
